

export default function CustomLink({ text, path, type = "normal", icon = false, colorType="default" , activeCss = ""}) {
    
    const baseStyles = "mx-md-3 my-2 transition1s brown-text-color";
  
    return (
      <a className={`${activeCss !== "" ? `${activeCss} ms-md-3` : ""} ${baseStyles}`} href={`/${path}`}>
        {text}
      </a>
    );
  }
    